/**
 * Item #14 — Three scannable outcomes / differentiators, derived
 * directly from the competitive-landscape report's headline numbers
 * (fragmentation costs $2.8k/yr; coach-controlled AI; COPPA/FERPA
 * first). Sits between the hero and the platform grid as the "what
 * makes this different" stripe.
 */
const ITEMS = [
  { value: "5–12", label: "Disconnected tools CastReady replaces" },
  { value: "1", label: "Coach-controlled AI workflow with a pro in the loop" },
  { value: "100%", label: "COPPA & FERPA aligned from day one" },
] as const;

export default function OutcomeStrip() {
  return (
    <div className="my-6 grid grid-cols-3 gap-2 sm:gap-3 rounded-2xl border border-border bg-card/60 backdrop-blur px-3 py-3">
      {ITEMS.map((i) => (
        <div key={i.label} className="text-center">
          <p className="text-lg sm:text-2xl font-semibold text-foreground tabular-nums leading-tight">{i.value}</p>
          <p className="text-[10px] sm:text-xs text-muted-foreground leading-snug mt-0.5">{i.label}</p>
        </div>
      ))}
    </div>
  );
}